import Vue from 'vue'
import axios from 'axios'

const $api = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
})

$api.interceptors.request.use(config => {
  // skip next if url is /driver/ghost-access
  if (config.url.includes('/driver/ghost-access')) {
    console.log('ghosted request', config.url);
    return config;
  }

  // legacy session upgrade: cpf + authTk in body, no bearer
  if (config.url.includes('/driver/auth/log') && config.data?.cpf && config.data?.authTk) {
    return config;
  }

  try {
    // Try to get user from localStorage or sessionStorage (exact method may need adjusting)
    let userStr = window.localStorage.getItem('user') || window.sessionStorage.getItem('user');
    if (userStr) {
      let user = JSON.parse(userStr);
      if (user && user.auth?.jwt) {
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${user.auth.jwt}`;
      }
    }
  } catch (e) {
    // Fails silently
  }
  return config;
}, error => {
  return Promise.reject(error);
});

Vue.prototype.$api = $api;

export default $api
